import { render } from "./TheAlarmTypesCreation.vue?vue&type=template&id=b51de052"
import script from "./TheAlarmTypesCreation.vue?vue&type=script&lang=js"
export * from "./TheAlarmTypesCreation.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__